module.exports = __webpack_public_path__ + "static/media/ios-thunderstorm.b8ef1498.svg";